import { render, staticRenderFns } from "./DoughnutGraph.vue?vue&type=template&id=10bcd8a9&scoped=true&"
import script from "./DoughnutGraph.vue?vue&type=script&lang=js&"
export * from "./DoughnutGraph.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutGraph.vue?vue&type=style&index=0&id=10bcd8a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bcd8a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10bcd8a9')) {
      api.createRecord('10bcd8a9', component.options)
    } else {
      api.reload('10bcd8a9', component.options)
    }
    module.hot.accept("./DoughnutGraph.vue?vue&type=template&id=10bcd8a9&scoped=true&", function () {
      api.rerender('10bcd8a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/chartjs/DoughnutGraph.vue"
export default component.exports